import Service from 'core/servicev2'
import type { AxiosError } from 'axios'

// Resource interface - PascalCase from OData
export interface Resource {
  ResourceKey: number
  CompanyID: string
  WorkerId: string
  WorkerName: string
  WorkerType: 'Employee' | 'Contractor' | string
  PersonnelNumber?: string
  IsActive: boolean
}

interface ResourceODataParams {
  $filter?: string
  $top?: number
  $skip?: number
  $orderby?: string
  $count?: boolean
  $search?: string
}

export const getWorkerTypeLabel = (type: number | string | undefined | null): string => {
  if (type === null || type === undefined) return '';

  const typeStr = type.toString();
  
  if (typeStr === '0' || typeStr.toLowerCase() === 'employee') {
    return 'Employee';
  }
  
  if (typeStr === '1' || typeStr.toLowerCase() === 'contractor') {
    return 'Contractor';
  }

  return typeStr;
}

class ResourceService extends Service {
  /**
   * Get resources with OData query support
   * GET /v2/Resource
   */
  getResources(params?: ResourceODataParams): Promise<any> {
    try {
      return this.get('/Resource', params)
    } catch (error) {
      throw (error as AxiosError).response
    }
  }

  /**
   * Search resources by name/workerId using OData filter
   */
  searchResources(searchTerm: string, top: number = 50): Promise<any> {
    const filter = `contains(tolower(WorkerName), '${searchTerm.toLowerCase()}') or contains(tolower(WorkerId), '${searchTerm.toLowerCase()}')`
    return this.getResources({
      $filter: filter,
      $top: top,
      $orderby: 'WorkerName'
    })
  }

  /**
   * GET /v2/master/resources-by-worker?workerId=xxx
   * Not under /Resource/ — OData parses /v2/Resource/{segment} as ResourceKey (int) and returns 500.
   */
  getResourcesByWorker(workerId: string): Promise<any> {
    try {
      return this.get('/master/resources-by-worker', { workerId })
    } catch (error) {
      throw (error as AxiosError).response
    }
  }
}

export default new ResourceService()
